module.exports = __webpack_public_path__ + "static/abricot-1b19bf7d0e8ad62b29107677c86da04f.svg";